import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';

let CorrectedForOversizeResults: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const DryOversizeIsZero = useSelector(pipe(createWorksheetSelector!('Results.OversizeDry'), (t) => t === 0));
  return (
    <>
      <ListFieldSection heading="Corrected for Oversize" visible={!DryOversizeIsZero}>
        <Field input={<TextOutput />} name="Results.AdjustedMaximumDryDensity" emph />
        <Field input={<TextOutput />} name="Results.AdjustedOptimumMoistureContent" emph />
      </ListFieldSection>
    </>
  );
};

CorrectedForOversizeResults = withInjectedProps(CorrectedForOversizeResults);

export { CorrectedForOversizeResults };
export default CorrectedForOversizeResults;
